import Vue from 'vue'
import App from './App.vue'
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import { Dialog } from 'vant';

Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(Dialog);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
